import React from 'react';

import Carousel from './Carousel';
import DiscountSection from '../pages/DiscountSection';
import VisionMissionSection from '../pages/VisionMissionSection';
import TestimonialsCarousel from './TestimonialsAndGallery';
import CounterSection from '../pages/CounterSection';
import WhyChooseMeghanaCabs from '../pages/WhyChooseUs';
import Populartours from '../pages/Popular';
import HomeOurfleet from '../pages/Homeourfleet';


const HeroSection = () => {

  return (


    <div className="th-hero-wrapper hero-1" id="hero">

      <Carousel />
      <DiscountSection />
      <VisionMissionSection />
      <Populartours />
      <TestimonialsCarousel />
      <WhyChooseMeghanaCabs />
      <CounterSection />
      <HomeOurfleet />
      
    </div>

  );
};

export default HeroSection;
